import React, {useEffect} from 'react';
import {deleteCookie, getCookie} from '../utils/cookies';
import {accessTokenKey, refreshTokenKey, usernameKey} from './AuthInterceptor';

export const parseJwt = (t?: string) => {
    if (!t) return null;
    try {
        return JSON.parse(atob(t.split('.')[1]));
    } catch {
        return null;
    }
};

export const isExpired = (t?: string) => {
    const p = parseJwt(t);
    if (!p?.exp) return true;
    return Date.now() >= p.exp * 1000;
};

const StartupTokenCleanup = () => {
    useEffect(() => {
        let cancelled = false;

        const cleanup = async () => {
            const access = getCookie(accessTokenKey);
            const refresh = getCookie(refreshTokenKey);

            if (!access && !refresh) return;

            const refreshExpired = refresh ? isExpired(refresh) : null;
            if (refresh && refreshExpired === true) {
                if (cancelled) return;
                deleteCookie(accessTokenKey);
                deleteCookie(refreshTokenKey);
                deleteCookie(usernameKey);
                return;
            }

            const accessExpired = access ? isExpired(access) : null;
            if (access && accessExpired === false) {
                return;
            }

            deleteCookie(accessTokenKey);
            deleteCookie(usernameKey);
        };

        cleanup();
        return () => {
            cancelled = true;
        };
    }, []);

    return null;
};

export default StartupTokenCleanup;
